import { Layers } from "appworks/graphics/layers/layers";
import { AbstractControl } from "appworks/ui/controls/abstract-control";
import { AutoStartControl } from "appworks/ui/controls/standard/button/auto-start-control";
import { ControlFactory } from "../control-factory";

export class AutoStartControlFactory implements ControlFactory {
    public filter(layer: Layers): boolean {
        if (layer.getFlexiButton("autoplay_start_button")) {
            return true;
        }
        return false;
    }

    public build(layer: Layers): AbstractControl[] {
        return [ new AutoStartControl(layer.getFlexiButton("autoplay_start_button")) ];
    }
}
